import React from "react";
import { FaTruck, FaGasPump, FaCogs, FaWeight, FaCheckCircle, FaTimesCircle } from "react-icons/fa";

function TruckDetails({ product }) {
    if (!product) return <p className="productspec-error">Məhsul detalları yüklənmir...</p>;

    const getStatus = (val, yes = "Bəli", no = "Xeyr") =>
        val === true ? yes : val === false ? no : "Bilinmir";

    const specs = [
        { label: "Ad", value: product.name, icon: <FaTruck /> },
        { label: "Qiymət", value: product.price ? `${product.price} AZN` : null },
        { label: "İl", value: product.year },
        { label: "Model", value: product.model },
        { label: "Yanacaq növü", value: product.fuelType, icon: <FaGasPump /> },
        { label: "Sürət qutusu", value: product.transmissionType, icon: <FaCogs /> },
        { label: "Kabin növü", value: product.cabinType },
        { label: "Mühərrik həcmi", value: product.engineVolume ? `${product.engineVolume} L` : null },
        { label: "Mühərrik gücü", value: product.enginePower },
        { label: "Daşıma qabiliyyəti", value: product.loadCapacity ? `${product.loadCapacity} ton` : null, icon: <FaWeight /> },
        { label: "Yürüş", value: product.mileage ? `${product.mileage} km` : null },
        { label: "Ötürücü", value: product.driveType },
        { label: "Platforma uzunluğu", value: product.platformLength ? `${product.platformLength} m` : null },
        { label: "Platforma eni", value: product.platformWidth ? `${product.platformWidth} m` : null },
        { label: "Rəng", value: product.color },
        { label: "Yeni?", value: getStatus(product.isNew), status: product.isNew },
        { label: "Qəzalı olub?", value: getStatus(product.isAccidented), status: product.isAccidented === false },
        { label: "VIN", value: product.vin },
        { label: "Bazar tipi", value: product.marketCountry },
        { label: "Şəhər", value: product.city },
        { label: "Alt Kateqoriya", value: product.subCategory },
        { label: "Kateqoriya", value: product.categoryName }
    ];

    return (
        <div className="productspec-container productspec-container--automotive">
            <div className="productspec-header">
                <FaTruck className="productspec-header__icon" />
                <h3 className="productspec-header__title">Yük Maşını Məlumatları</h3>
            </div>

            <div className="productspec-grid">
                {specs.map((spec, index) => {
                    if (!spec.value || spec.value === "Bilinmir") return null;
                    
                    return (
                        <div key={index} className="productspec-item">
                            {spec.icon && <span className="productspec-item__icon">{spec.icon}</span>}
                            <div className="productspec-item__content">
                                <span className="productspec-item__label">{spec.label}</span>
                                <span className={`productspec-item__value ${spec.status !== undefined ? (spec.status ? 'productspec-item__value--success' : 'productspec-item__value--danger') : ''}`}>
                                    {spec.status !== undefined && (
                                        spec.status ? <FaCheckCircle className="productspec-status-icon productspec-status-icon--success" /> : <FaTimesCircle className="productspec-status-icon productspec-status-icon--danger" />
                                    )}
                                    {spec.value}
                                </span>
                            </div>
                        </div>
                    );
                })}
            </div>

            {product.description && (
                <div className="productspec-description">
                    <h4 className="productspec-description__title">Əlavə Təsvir</h4>
                    <p className="productspec-description__text">{product.description}</p>
                </div>
            )}
        </div>
    );
}

export default TruckDetails;